import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type AncAwaitingFinalisationCountQueryVariables = Types.Exact<{
  input: Types.QueryAncEncountersInput;
}>;


export type AncAwaitingFinalisationCountQuery = { readonly __typename?: 'Query', readonly ancEncounters: { readonly __typename?: 'AncEncounterPage', readonly total?: number | null } };

export type AncRegisterQueryVariables = Types.Exact<{
  input: Types.QueryAncEncountersInput;
}>;


export type AncRegisterQuery = { readonly __typename?: 'Query', readonly ancEncounters: { readonly __typename?: 'AncEncounterPage', readonly skip?: number | null, readonly take?: number | null, readonly total?: number | null, readonly encounters: ReadonlyArray<{ readonly __typename?: 'AncEncounter', readonly id: string, readonly createdAt: string, readonly status: Types.AncEncounterStatus, readonly dueDate?: string | null, readonly parityDeliveries?: number | null, readonly parityMiscarriages?: number | null, readonly lastMenstrualPeriod?: string | null, readonly ageOfPregnancy?: number | null, readonly visitNumber?: number | null, readonly iptpDoseOverride?: number | null, readonly earlyInitiationOfBreastfeeding?: boolean | null, readonly exclusiveBreastfeeding?: boolean | null, readonly femaleGenitalMutilation?: boolean | null, readonly hivTesting?: boolean | null, readonly maternalNutrition?: boolean | null, readonly longLastingInsecticidalNet?: boolean | null, readonly investigations?: ReadonlyArray<{ readonly __typename?: 'InvestigationActivity', readonly _id: string, readonly catalogueItem: { readonly __typename?: 'InvestigationActivityItem', readonly title: string }, readonly outcome?: { readonly __typename?: 'InvestigationRequestOutcome', readonly _id: string } | null } | null> | null, readonly prescriptions?: ReadonlyArray<{ readonly __typename?: 'InpatientPrescription', readonly id: string, readonly clinicalProduct?: { readonly __typename?: 'Amp', readonly title: string, readonly id: string } | { readonly __typename?: 'Vmp', readonly title: string, readonly id: string } | null } | null> | null, readonly patient?: { readonly __typename?: 'Patient', readonly uuid: string, readonly cardId?: string | null, readonly passport?: { readonly __typename?: 'Passport', readonly uid: string } | null, readonly person: { readonly __typename?: 'Person', readonly dob: string, readonly name: { readonly __typename?: 'Name', readonly fullname?: string | null } } } | null } | null> } };


export const AncAwaitingFinalisationCountDocument = gql`
    query AncAwaitingFinalisationCount($input: QueryAncEncountersInput!) {
  ancEncounters(input: $input) {
    total
  }
}
    `;

/**
 * __useAncAwaitingFinalisationCountQuery__
 *
 * To run a query within a React component, call `useAncAwaitingFinalisationCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useAncAwaitingFinalisationCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAncAwaitingFinalisationCountQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAncAwaitingFinalisationCountQuery(baseOptions: Apollo.QueryHookOptions<AncAwaitingFinalisationCountQuery, AncAwaitingFinalisationCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AncAwaitingFinalisationCountQuery, AncAwaitingFinalisationCountQueryVariables>(AncAwaitingFinalisationCountDocument, options);
      }
export function useAncAwaitingFinalisationCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AncAwaitingFinalisationCountQuery, AncAwaitingFinalisationCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AncAwaitingFinalisationCountQuery, AncAwaitingFinalisationCountQueryVariables>(AncAwaitingFinalisationCountDocument, options);
        }
export type AncAwaitingFinalisationCountQueryHookResult = ReturnType<typeof useAncAwaitingFinalisationCountQuery>;
export type AncAwaitingFinalisationCountLazyQueryHookResult = ReturnType<typeof useAncAwaitingFinalisationCountLazyQuery>;
export type AncAwaitingFinalisationCountQueryResult = Apollo.QueryResult<AncAwaitingFinalisationCountQuery, AncAwaitingFinalisationCountQueryVariables>;
export const AncRegisterDocument = gql`
    query AncRegister($input: QueryAncEncountersInput!) {
  ancEncounters(input: $input) {
    skip
    take
    total
    encounters {
      id
      createdAt
      status
      dueDate
      parityDeliveries
      parityMiscarriages
      lastMenstrualPeriod
      ageOfPregnancy
      visitNumber
      iptpDoseOverride
      earlyInitiationOfBreastfeeding
      exclusiveBreastfeeding
      femaleGenitalMutilation
      hivTesting
      maternalNutrition
      longLastingInsecticidalNet
      investigations {
        _id
        catalogueItem {
          title
        }
        outcome {
          _id
        }
      }
      prescriptions {
        id
        clinicalProduct {
          ... on Vmp {
            title
            id
          }
          ... on Amp {
            title
            id
          }
        }
      }
      patient {
        uuid
        cardId
        passport {
          uid
        }
        person {
          name {
            fullname
          }
          dob
        }
      }
    }
  }
}
    `;

/**
 * __useAncRegisterQuery__
 *
 * To run a query within a React component, call `useAncRegisterQuery` and pass it any options that fit your needs.
 * When your component renders, `useAncRegisterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAncRegisterQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAncRegisterQuery(baseOptions: Apollo.QueryHookOptions<AncRegisterQuery, AncRegisterQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AncRegisterQuery, AncRegisterQueryVariables>(AncRegisterDocument, options);
      }
export function useAncRegisterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AncRegisterQuery, AncRegisterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AncRegisterQuery, AncRegisterQueryVariables>(AncRegisterDocument, options);
        }
export type AncRegisterQueryHookResult = ReturnType<typeof useAncRegisterQuery>;
export type AncRegisterLazyQueryHookResult = ReturnType<typeof useAncRegisterLazyQuery>;
export type AncRegisterQueryResult = Apollo.QueryResult<AncRegisterQuery, AncRegisterQueryVariables>;